import { render, staticRenderFns } from "./ProductProperties.vue?vue&type=template&id=72b47b54&scoped=true"
import script from "./ProductProperties.vue?vue&type=script&lang=js"
export * from "./ProductProperties.vue?vue&type=script&lang=js"
import style0 from "./ProductProperties.vue?vue&type=style&index=0&id=72b47b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b47b54",
  null
  
)

export default component.exports